module.exports = __webpack_public_path__ + "img/plus.b50e3ea6.svg";